<template>
  <div class="language-switcher">
    <img
      v-for="lang in languages"
      :key="lang.value"
      :src="lang.icon"
      :alt="lang.label"
      class="flag"
      :class="{ selected: currentLocale === lang.value }"
      @click="changeLanguage(lang.value)"
      title="lang.label"
    />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const languages = [
  { label: 'English', value: 'en', icon: 'https://flagcdn.com/w40/gb.png' },
  { label: 'Русский', value: 'ru', icon: 'https://flagcdn.com/w40/ru.png' },
  { label: 'Eesti', value: 'et', icon: 'https://flagcdn.com/w40/ee.png' },
]

const { locale } = useI18n()
const currentLocale = ref(locale.value)

function changeLanguage(lang) {
  locale.value = lang
  currentLocale.value = lang
  localStorage.setItem('locale', lang)
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flag {
  width: 32px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid transparent;
  transition: border-color 0.3s ease, transform 0.15s ease;
}

.flag:hover {
  border-color: #40c1ac;
  transform: scale(1.1);
}

.flag.selected {
  border-color: #40c1ac;
  box-shadow: 0 0 8px #40c1ac;
  transform: scale(1.2);
}
</style>
